import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from '@/components/ui/sonner';
import { useAuth } from '@/hooks/useAuth';
import { authAPI } from '@/services/api';
import { t } from '@/i18n/translations';
import { formatApiError } from '@/lib/apiError';
import { AuthShell } from '@/components/layout/AuthShell';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function ForgotPasswordPage() {
  const { lang } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.forgotPassword(email.trim());
      setSubmitted(true);
    } catch (err) {
      toast.error(formatApiError(err, t('generic_error', lang)));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      lang={lang}
      title={t('forgot_password_title', lang)}
      description={t('forgot_password_subtitle', lang)}
    >
      {submitted ? (
        <div className="space-y-6">
          <div className="rounded-lg border border-success/30 bg-success/10 p-4 text-sm text-foreground">
            {t('forgot_password_sent', lang)}
          </div>
          <Link
            to="/login"
            className="inline-block text-sm font-medium text-primary hover:underline"
          >
            {t('back_to_login', lang)}
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-1.5">
            <Label htmlFor="email">{t('email', lang)}</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="utilizador@empresa.pt"
              required
            />
          </div>
          <Button type="submit" className="w-full" disabled={loading} size="lg">
            {loading ? t('sending', lang) : t('send_reset_link', lang)}
          </Button>
          <div className="text-center text-sm text-muted-foreground">
            <Link to="/login" className="font-medium text-primary hover:underline">
              {t('back_to_login', lang)}
            </Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
